const RANKING = [
  { rank: 1, title: '暗影猎手', tag: '热血', score: '9.6', trend: 'up', change: '+2' },
  { rank: 2, title: '星辰变·外传', tag: '奇幻', score: '9.5', trend: 'up', change: '+5' },
  { rank: 3, title: '机甲战神', tag: '科幻', score: '9.4', trend: 'down', change: '-1' },
  { rank: 4, title: '恋爱方程式', tag: '恋爱', score: '9.3', trend: 'same', change: '—' },
  { rank: 5, title: '剑道无双', tag: '热血', score: '9.2', trend: 'up', change: '+3' },
  { rank: 6, title: '都市灵异录', tag: '悬疑', score: '9.1', trend: 'down', change: '-2' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            人气排行
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时更新读者评分与热度排名，发现最受欢迎的漫画
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {RANKING.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer border-b border-background-200 last:border-b-0"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400/80 text-background-50' :
                item.rank === 3 ? 'bg-primary-300/80 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-heading font-bold text-foreground-900 truncate">{item.title}</span>
                  <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] rounded-full bg-accent-100 text-accent-700 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-amber-400 text-xs"></i>
                  <span className="text-sm font-semibold text-foreground-800">{item.score}</span>
                </div>
                <span className={`text-xs font-medium whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-600' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-500'
                }`}>
                  {item.change}
                  {item.trend === 'up' && <i className="ri-arrow-up-s-line ml-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-s-line ml-0.5"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}